"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.claimSchema = void 0;
var property_takeover_schema_1 = require("./property-takeover-schema");
var property_listing_schema_1 = require("./property-listing-schema");
exports.claimSchema = {
    type: ['object', 'null'],
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'cmhcLoanAccountNumber',
        'additionalSecurityTypeCode',
        'claimFilingExtensionIndicator',
        'claimProcessTypeCode',
        'claimTypeCode',
        'contestedEvictionIndicator',
        'creditFinancialRecoverIndicator',
        'enhancedAcppIndicator',
        'legalActionTypeCode',
        'lenderLegalActionTypeCode',
        'lenderOfficerLocalFaxNumber',
        'lenderOfficerLocalTelephoneNumber',
        'lenderOfficerName',
        'lenderRepresentativeInformationText',
        'mortgagePaymentDeferralCount',
        'propertyTitleWarrantyTypeCode',
        'propertyTransferPartyTypeCode',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
    ],
    properties: {
        cmhcLoanAccountNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        additionalSecurityTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        borrowerVacatedPropertyDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        claimFilingExtensionIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        claimProcessTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        claimTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        contestedEvictionIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        creditFinancialRecoverIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        enhancedAcppIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        legalActionEndDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        legalActionStartDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        legalActionTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        lenderLegalActionTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        lenderOfficerLocalFaxNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should have maximum length of 10 characters',
        },
        lenderOfficerLocalTelephoneNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should have maximum length of 10 characters',
        },
        lenderOfficerName: {
            type: 'string',
            minLength: 0,
            maxLength: 30,
            errorMessage: 'should have variable length up to 30 characters',
        },
        lenderRepresentativeInformationText: {
            type: 'string',
            minLength: 0,
            maxLength: 60,
            errorMessage: 'should have variable length up to 60 characters',
        },
        lenderTitleAcquiredDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        mortgagePaymentDeferralCount: {
            type: 'integer',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        propertyTitleWarrantyTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        propertyTransferPartyTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        purchaseOfferAcceptedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        underwritingDocumentReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        underwritingDocumentRequestedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        underwritingReviewEndDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        underwritingReviewStartDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        propertyListings: {
            type: ['array', 'null'],
            items: property_listing_schema_1.propertyListingSchema,
        },
        propertyTakeover: property_takeover_schema_1.propertyTakeoverSchema,
    },
};
